import { useNavigate } from "react-router-dom";
import { Header } from "../components/Header";
import { HomeHero } from "../components/home/HomeHero";
import { XmasBanner } from "../components/home/XmasBanner";
import { GiftStrip } from "../components/home/GiftStrip";
import { HowItWorks, Paths, SizesSports, ShieldWall, LayoutCompare } from "../components/home/HomeSections";
import { PublicFooter } from "../components/PublicChrome";
import { useSeo, ORGANIZATION, SITE_URL } from "../lib/seo";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { ReviewStrip } from "../components/ReviewStrip";

const FAQ = [
  ["Do I need to join a club to order?", "No. Choose Individual order, design your shield and pay – no account needed."],
  ["How does the club fundraiser work?", "A coach signs up, sets the club look and shares one parent link. Each parent adds their child's photo and statistics and pays for their own shield, and the club raises funds on every shield ordered."],
  ["Who enters the statistics?", "Parents can enter their own child's statistics, or the coach can – the coach decides in the squad settings."],
  ["What photo works best?", "A clear, well-lit photo. Tap 'Remove background' and the player will stand right on the shield design."],
  ["What sizes are available?", "Small 210×300 mm, Medium 300×420 mm, Large 420×594 mm and Extra Large 594×840 mm."],
];

export default function Home() {
  const nav = useNavigate();
  useSeo({
    title: "Personalised Football Cards & Player Shields Ireland", path: "/",
    description: "Personalised football cards & player shields for soccer, GAA and rugby players in Ireland – photo, name, crest and stats. Printed from €16.",
    jsonLd: { "@context": "https://schema.org", "@graph": [ORGANIZATION,
      { "@type": "WebSite", name: "sportsshields.ie", url: `${SITE_URL}/`, publisher: { "@id": `${SITE_URL}/#org` } },
      { "@type": "FAQPage", mainEntity: FAQ.map(([q, a]) => ({ "@type": "Question", name: q, acceptedAnswer: { "@type": "Answer", text: a } })) }] },
  });
  return (
    <div className="min-h-screen">
      <Header onNew={() => nav("/design")} />
      <XmasBanner />
      <HomeHero />
      <HowItWorks />
      <LayoutCompare />
      <GiftStrip />
      <Paths />
      <ShieldWall />
      <ReviewStrip />
      <SizesSports />
      <section className="mx-auto max-w-3xl px-4 pb-20 sm:px-6" data-testid="home-faq">
        <div className="eyebrow">FAQ</div>
        <h2 className="font-display mt-1 mb-6 text-3xl font-black uppercase tracking-tight sm:text-4xl">Questions</h2>
        <Accordion type="single" collapsible className="space-y-2">
          {FAQ.map(([q, a], i) => (
            <AccordionItem key={q} value={`q${i}`} className="border-2 border-slate-200 bg-white px-4" data-testid={`home-faq-${i}`}>
              <AccordionTrigger className="text-left font-bold hover:no-underline">{q}</AccordionTrigger>
              <AccordionContent className="text-slate-600">{a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </section>
      <PublicFooter />
    </div>
  );
}
